import { createContext, useContext } from 'react';

export interface DemoViewer {
  fullName: string;
  email: string;
}

export interface DemoLocationState {
  demoViewer?: DemoViewer;
}

export interface DemoSession {
  viewer: DemoViewer | null;
  exitPath: string;
}

export const DemoSessionContext = createContext<DemoSession | null>(null);

export const useDemoSession = () => useContext(DemoSessionContext);
